export enum ErrorStatus {
  MAINTENANCE_ERROR_STATUS = 503,
  CARD_REQUIRED_ERROR_STATUS = '40061',
  ENTRY_ENDED_EVENT_ERROR_STATUS = '40051',
  ENTRY_DELETED_EVENT_ERROR_STATUS = '40413',
}
